import { render, staticRenderFns } from "./Sys_ml_seminar.vue?vue&type=template&id=2918148b"
import script from "./Sys_ml_seminar.vue?vue&type=script&lang=js"
export * from "./Sys_ml_seminar.vue?vue&type=script&lang=js"
import style0 from "./Sys_ml_seminar.vue?vue&type=style&index=0&id=2918148b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports